// Smart Device Insurance Stepper Data
export const smartDeviceStepperData = [
  {
    key: 'START',
    title_en: 'Start',
    title_ar: 'ابدأ',
  },
  {
    key: 'DEVICE',
    title_en: 'Device',
    title_ar: 'الجهاز',
  },
  {
    key: 'PURCHASE_DETAILS',
    title_en: 'Purchase Details',
    title_ar: 'تفاصيل الشراء',
  },
  {
    key: 'INFORMATION',
    title_en: 'Information',
    title_ar: 'بياناتك',
  },
  {
    key: 'REVIEW_PAY',
    title_en: 'Pay',
    title_ar: 'المراجعة والدفع',
  },
];

// Smart Device Insurance Flow Steps
export const SMART_DEVICE_STEP_NAME_START = 'START';
export const SMART_DEVICE_STEP_NAME_DEVICE = 'DEVICE';
export const SMART_DEVICE_STEP_NAME_PURCHASE_DETAILS = 'PURCHASE_DETAILS';
export const SMART_DEVICE_STEP_NAME_INFORMATION = 'INFORMATION';
export const SMART_DEVICE_STEP_NAME_REVIEW_PAY = 'REVIEW_PAY';
export const SMART_DEVICE_STEP_NAME_PAY = 'PAY';

// Smart Device Insurance Flow Definition
export const smart_device_insurance_flow = {
  default: [
    {
      name: SMART_DEVICE_STEP_NAME_START,
      substeps: ['basic_info', 'document_check'],
    },
    {
      name: SMART_DEVICE_STEP_NAME_DEVICE,
      substeps: ['device_selection'],
    },
    {
      name: SMART_DEVICE_STEP_NAME_PURCHASE_DETAILS,
      substeps: ['device_information'],
    },
    {
      name: SMART_DEVICE_STEP_NAME_INFORMATION,
      substeps: ['contact_details'],
    },
    {
      name: SMART_DEVICE_STEP_NAME_REVIEW_PAY,
      substeps: ['review_and_confirm'],
    },
  ],
};

// Device Types
export const DEVICE_TYPES = {
  SMARTPHONE: 'smartphone',
  TABLET: 'tablet',
  SMARTWATCH: 'smartwatch',
  MACBOOK: 'macbook',
};

// IMEI Input Methods (for smartphones)
export const IMEI_INPUT_METHODS = {
  MANUAL: 'manual',
  SCREENSHOT: 'screenshot',
};
